import queryString from "query-string";
import { useCallback, useEffect, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  ctaClickEvent,
  formAbandonmentEvent,
  formFieldErrorEvent,
  formIntermediateEvent,
  formStartEvent,
  formSubmissionFailEvent,
  formSuccessEvent,
} from "../services/adobeDataLayer.js";
import {
  callLSQLapp,
  DataLayerEvent,
  encryptBody,
  getLsqLeadBody,
  setValuesInLocalStorange,
} from "../services/lsq.js";
import { notifySuccess, notifyWarn } from "../services/Toastifyfn";

function Form() {
  let navigate = useNavigate();
  const initialValues = {
    username: "",
    email: "",
    mobile: "",
    otp: "",
    pan: "",
    pin: "",
    city: "",
    homeLoanAmountRequired: "",
    amountInWords: "",
  };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [checked, setChecked] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [newMargin, setNewMargin] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const handleOpenModal = () => setShowModal(true);

  //States for Mobile, OTP, Timer and Resend Button
  const [disableMobileField, setDisableMobileField] = useState(false);
  const [token, setToken] = useState("");
  const [otpsent, setOtpsent] = useState(false);
  const [disableOTPField, setDisableOTPField] = useState(false);
  const [otpBtnText, setOtpBtnText] = useState("Resend");
  const [resendBtnDisplay, hideDisplayBtn] = useState("initial");
  const [disableVerifiedButton, setDisableVerifiedButton] = useState(false);
  const [timer, setTimer] = useState(0);
  const [timerDisplay, setTimerDisplay] = useState("none");
  //States for Pincode and City
  const [cityName, setCityname] = useState("");
  const [citydefined, setCitydefined] = useState(false);
  //State for Apply Button
  const [disableApplyBtn, setApplyBtnDisable] = useState(false);
  //States for FBP, FBC
  const [fbp, setFbp] = useState("");
  const [fbc, setFbc] = useState("");
  const [cookies, setCookie] = useCookies();

  //Adobe
  const hasTriggeredFormStart = useRef(false);
  let lastAccessedField = "na";

  //States for Data Layer
  const [eventFired, setEventFired] = useState({
    username: false,
    pan: false,
    email: false,
    mobile: false,
    otp: false,
    terms_chk: false,
    pin: false,
    homeLoanAmountRequired: false,
  });

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      // console.log("lead form started: ", hasTriggeredFormStart.current)
      // Custom logic to be executed before tab or window is closed
      if (hasTriggeredFormStart.current) {
        formAbandonmentEvent(
          "LAP lead form",
          "lead generation",
          lastAccessedField,
          "details",
        );
        console.table(window.adobeDataLayer);
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    //Clean Up
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  //TIMER EFFECTS
  const timeOutCallback = useCallback(
    () => setTimer((currTimer) => currTimer - 1),
    [],
  );
  useEffect(() => {
    if (formValues.mobile.length === 10 && otpsent) {
      timer > 0 && setTimeout(timeOutCallback, 1000);
    }
  }, [timer, timeOutCallback, formValues.mobile, otpsent]);

  //set Fbp, Fbc values
  useEffect(() => {
    setFbp(cookies["_fbp"] || "");
    setFbc(cookies["_fbc"] || "");
  }, []);
  formValues.FBClickID = fbc;
  formValues.FBPixelID = fbp;

  //SENDING AND VERIFYING OTP
  useEffect(() => {
    let mobileVal = formValues["mobile"];
    let OTP = formValues["otp"] ? formValues["otp"] : "";
    if (mobileVal !== undefined) {
      if (mobileVal.length === 10) {
        if (mobileVal.length === 10 && otpsent === false) {
          sendOTPText(mobileVal);
        }

        if (mobileVal.length !== 10) {
          setOtpsent(false);
        }
        if (OTP.length === 6 && mobileVal.length === 10 && token === "") {
          verifyOTPText(mobileVal, OTP);
        }
      }
    }
  }, [token, formValues["otp"], formValues["mobile"]]);

  // sending otp
  const sendOTPText = async (mobileNumber, option) => {
    if (mobileNumber.length === 10 && mobileNumber.match(/^[6-9]\d{9}$/)) {
      let payload = { mobile: mobileNumber, messageType: "otpGeneral" };
      let param = { otp: "send" };
      const otpResponse = await callLSQLapp(payload, "OTP", param);
      if (otpResponse?.data?.message?.response?.sent) {
        //Trigger AA Form Intermediate Event for OTP Receive
        if (option === "resend") {
          ctaClickEvent("otp:resend", "lead form", "button", 0, "na");
        } else {
          formIntermediateEvent("receive", "otp");
        }
        notifySuccess("OTP has been sent to your mobile number.");
        setDisableMobileField(true);
        setOtpsent(true);
        setTimerDisplay("inline");
        setTimer(30);
      } else {
        notifyWarn("Please Resend OTP.");
        setDisableMobileField(true);
        setTimerDisplay("none");
        setOtpsent(false);
      }
    }
  };

  // verifyOTP
  const verifyOTPText = async (mobileNum, otpValue) => {
    let payload = { mobile: mobileNum, otp: otpValue };
    let param = { otp: "verify" };
    let currentError = {};
    const otpVerifyResponse = await callLSQLapp(payload, "OTP", param);
    if (
      otpVerifyResponse.data.message === "Failure Occured, please check logs"
    ) {
      currentError["otp"] = "Invalid OTP entered";
      notifyWarn("Invalid OTP");
      formValues.otp = "";
      setFormErrors(currentError);
      return;
    }
    const tokenValue =
      otpVerifyResponse.data.message.response.dataSent.UniqueID;

    setToken(tokenValue);
    formValues.otp = otpValue;
    setDisableMobileField(true);
    setDisableOTPField(true);
    setTimer(0);
    setDisableVerifiedButton(true);
    hideDisplayBtn("initial");
    setOtpBtnText("Verified");
    //Trigger AA Form Intermediate Event for OTP Verify
    formIntermediateEvent("verified", "otp");
    notifySuccess("OTP Verified Successfully.");
  };

  const handleFormStart = () => {
    if (!hasTriggeredFormStart.current) {
      formStartEvent("LAP lead form", "lead generation", "details");
      hasTriggeredFormStart.current = true;
    }
  };

  // Format number with Indian commas
  const formatIndianNumber = (numStr) => {
    let num = numStr.replace(/,/g, "");
    let x = num.split(".");
    let lastThree = x[0].substring(x[0].length - 3);
    let otherNumbers = x[0].substring(0, x[0].length - 3);
    if (otherNumbers !== "") lastThree = "," + lastThree;
    let formatted =
      otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
    return x.length > 1 ? formatted + "." + x[1] : formatted;
  };

  // Convert number to Indian-style words
  const numToWords = (n) => {
    const ones = [
      "",
      "one",
      "two",
      "three",
      "four",
      "five",
      "six",
      "seven",
      "eight",
      "nine",
    ];
    const teens = [
      "ten",
      "eleven",
      "twelve",
      "thirteen",
      "fourteen",
      "fifteen",
      "sixteen",
      "seventeen",
      "eighteen",
      "nineteen",
    ];
    const tens = [
      "",
      "",
      "twenty",
      "thirty",
      "forty",
      "fifty",
      "sixty",
      "seventy",
      "eighty",
      "ninety",
    ];
    let word = "";
    if (n >= 100) {
      word += ones[Math.floor(n / 100)] + " hundred ";
      n %= 100;
    }
    if (n >= 20) {
      word += tens[Math.floor(n / 10)] + " ";
      n %= 10;
    } else if (n >= 10) {
      word += teens[n - 10] + " ";
      return word.trim(); // Early return for teens
    }
    if (n > 0) {
      word += ones[n] + " ";
    }
    return word.trim();
  };

  const convertToWords = (numStr) => {
    const num = parseInt(numStr, 10);

    if (num === 0) return "Zero";
    if (num === 1000000000) return "One Hundred Crore";

    let words = "";

    // --- Conversion Logic ---
    const crore = Math.floor(num / 10000000);
    const lakh = Math.floor((num % 10000000) / 100000);
    const thousand = Math.floor((num % 100000) / 1000);
    const remaining = num % 1000;

    if (crore > 0) {
      words += numToWords(crore) + " crore ";
    }
    if (lakh > 0) {
      words += numToWords(lakh) + " lakh ";
    }
    if (thousand > 0) {
      words += numToWords(thousand) + " thousand ";
    }
    if (remaining > 0) {
      words += numToWords(remaining);
    }

    // Capitalize the first letter and trim whitespace
    const finalWords = words.trim();
    return finalWords.charAt(0).toUpperCase() + finalWords.slice(1);
  };

  const handleChange = async (e) => {
    handleFormStart();
    var { name, value } = e.target;

    const fireDataLayerEvent = (eventName) => {
      if (!eventFired[name]) {
        DataLayerEvent(
          "",
          "",
          "custom_event",
          "home_loan_campaign",
          "lap",
          eventName,
          true,
        );
        setEventFired({ ...eventFired, [name]: true });
      }
    };

    if (name === "username") {
      const words = value.split(" ");
      for (let i = 0; i < words.length; i++) {
        words[i] =
          words[i].charAt(0).toUpperCase() + words[i].slice(1).toLowerCase();
      }
      value = words.join(" ");
    }
    if (name === "pan") {
      value = value.replace(/\s\s+/g, " ");
      value = value.toUpperCase();
      value = value.replace(/[^a-zA-Z0-9]/g, "");
      if (
        (value.length <= 5 && /[^a-zA-Z]/.test(value)) ||
        (value.length === 10 && /^[^a-zA-Z]/.test(value.slice(-1)))
      ) {
        value = value.slice(0, -1);
      } else if (
        value.length > 5 &&
        value.length <= 9 &&
        /[^0-9]$/.test(value.slice(5, 9))
      ) {
        value = value.slice(0, -1);
      }
    }

    let error = "";
    let nameRegex = /^[a-zA-Z ]*$/;
    let emailRegex =
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i;
    let mobileRegex = /^[6-9]\d{9}$/;
    let otpRegex = /^\d{6}$/;
    let pincodeRegex = /^\d{6}$/;
    let panRegex = /^[A-Za-z]{5}\d{4}[A-Za-z]$/;

    if (name === "username") {
      fireDataLayerEvent("name_entered");
      if (!value) {
        error = "Please enter your name";
      } else if (!nameRegex.test(value)) {
        error = "Please enter valid name";
      }
    }
    if (name === "email") {
      fireDataLayerEvent("email_address_entered");
      if (!value) {
        error = "Please enter your email";
      } else if (!emailRegex.test(value)) {
        error = "Please enter valid email";
      }
    }
    if (name === "mobile") {
      fireDataLayerEvent("mob_number_entered");
      if (!value) {
        error = "Please enter your mobile";
      } else if (!mobileRegex.test(value)) {
        error = "Please enter valid mobile";
      }
    }
    if (name === "otp") {
      fireDataLayerEvent("otp_entered");
      if (!value) {
        error = "Please enter OTP";
      } else if (!otpRegex.test(value)) {
        error = "Please enter valid OTP";
      }
    }
    if (name === "pan") {
      fireDataLayerEvent("pan_number_entered");
      if (!value) {
        error = "Please enter your pan number";
      } else if (!panRegex.test(value)) {
        error = "Please enter valid pan number";
      }
    }
    if (name === "pin") {
      fireDataLayerEvent("pincode_entered");
      let cityExists;
      if (value.length === 6) {
        setCityname("Fetching...");
        let payload = { pincode: value };
        let param = { type: "pincode" };
        const response = await callLSQLapp(payload, "MAVIS", param);
        const { uniqueArray, filteredCount } = response.data.message;
        if (filteredCount > 0) {
          cityExists = true;
          var CityNameIs = uniqueArray[0].District;
          console.log("cityName is", CityNameIs);
          setCityname(CityNameIs);
          setCitydefined(true);
        } else {
          cityExists = false;
          error = "Please enter valid pincode.";

          setCityname("City not found");
          setCitydefined(false);
        }
      }
      formValues.pin = value;
      formValues.city = CityNameIs;
      if (!value) {
        error = "Please enter your pincode";
      } else if (value && !pincodeRegex.test(value)) {
        error = "Please enter valid pincode";
      } else if (value && pincodeRegex.test(value) && !cityExists) {
        error = "Please enter valid pincode";
      }
    }
    if (name === "terms_chk") {
      //Trigger ctaClick event for checkbox field
      ctaClickEvent(
        `consent checkbox: ${e.target.checked}`,
        "lead form",
        "checkbox",
        0,
        "na",
      );
      if (!e.target.checked) {
        error = "Please accept terms and conditions";
      }
    }
    if (name === "homeLoanAmountRequired") {
      fireDataLayerEvent("homeLoanAmountRequired");
      if (!value) {
        error = "Please select loan against property amount required";
      }
      // Only keep digits
      // value = value.replace(/\D/g, "");
      // if (!value) {
      //   error = "Please select loan against property amount required";
      // } else {
      //   formValues.amountInWords = convertToWords(value);
      //   value = formatIndianNumber(value);
      // }
    }

    setFormValues({ ...formValues, [name]: value });
    setFormErrors({
      ...formErrors,
      [name]: error,
    });
    setNewMargin(true);
  };

  const validate = (values) => {
    const errors = {};
    let nameRegex = /^[a-zA-Z ]*$/;
    let emailRegex =
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i;
    let mobileRegex = /^[6-9]\d{9}$/;
    let otpRegex = /^\d{6}$/;
    let pincodeRegex = /^\d{6}$/;
    let panRegex = /^[A-Za-z]{5}\d{4}[A-Za-z]$/;

    if (!values.username) {
      errors.username = "Please enter your name";
    } else if (!nameRegex.test(values.username)) {
      errors.username = "Please enter valid name";
    }
    if (!values.email) {
      errors.email = "Please enter your email";
    } else if (!emailRegex.test(values.email)) {
      errors.email = "Please enter valid email";
    }

    if (!values.mobile) {
      errors.mobile = "Please enter your mobile";
    } else if (!mobileRegex.test(values.mobile)) {
      errors.mobile = "Please enter valid mobile";
    }

    if (!values.otp) {
      errors.otp = "Please enter OTP";
    } else if (!otpRegex.test(values.otp)) {
      errors.otp = "Please enter valid OTP";
    }

    if (!values.pan) {
      errors.pan = "Please enter your pan number";
    } else if (!panRegex.test(values.pan)) {
      errors.pan = "Please enter valid pan number";
    }

    if (!values.pin && !citydefined) {
      errors.pin = "Please enter your pincode";
    } else if (!pincodeRegex.test(values.pin)) {
      errors.pin = "Please enter valid pincode";
    }

    if (!checked) {
      errors.terms_chk = "Please accept terms and conditions";
    }

    if (!values.homeLoanAmountRequired) {
      errors.homeLoanAmountRequired =
        "Please select loan against property amount required";
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validateFormValues = validate(formValues);
    setFormErrors(validateFormValues);
    setNewMargin(true);

    if (Object.keys(validateFormValues).length === 0) {
      setApplyBtnDisable(true);
      DataLayerEvent(
        formValues.email,
        formValues.mobile,
        "custom_event",
        "lap_campaign",
        "apply_now_clicked",
        "NA",
        true,
      );
      const utmParamsObj = queryString.parse(window.location.search);
      for (const [key, value] of Object.entries(utmParamsObj)) {
        formValues[key] = value;
      }
      formValues.CampaignId = "819305";
      formValues.ApiProductName = "LAP";
      formValues.ApiCompanyName = "internal";
      formValues.ParentProduct = "Loan Against Property";
      formValues.ModeOfLead = "landing-page";
      formValues.token = token;
      formValues.IsEligible = "Yes";
      formValues.EligibilityReason = "";
      formValues.CompleteUrl = window.location.href;
      formValues.User_Agent = navigator.userAgent;
      if (checked) {
        formValues.DND = "Yes";
        formValues.terms_chk = true;
      } else {
        formValues.DND = "No";
        formValues.terms_chk = false;
      }

      await setValuesInLocalStorange(formValues["email"], formValues["mobile"]);

      let payload = {
        mobile: formValues.mobile,
        otp: formValues.otp,
        formdata: getLsqLeadBody(formValues),
      };
      console.log("Lead Create Payload", payload);

      //Encrypt Payload
      const encryptedPayload = await encryptBody(payload);
      // console.log("Lead Create encrypted Payload", encryptedPayload);

      let param = {};
      let createLeadResp = await callLSQLapp(encryptedPayload, "CREATE", param);
      if (
        createLeadResp.data.message !== "Failure occured , please check logs"
      ) {
        let leadid = createLeadResp.data.message.Data.LeadApiCalls.Message.Id;
        console.log("leadID", leadid);
        //Trigger AA formSuccess event
        formSuccessEvent(
          "LAP lead form",
          {
            otp: formValues.otp,
            pincode: formValues.pin,
            city: formValues.city,
          },
          "lead generation",
          "thank you",
          true,
        );

        navigate(`/thankyou?id=${leadid}`);

        // let criffPayload = {
        //   Current: {
        //     ProspectID: leadid,
        //     FirstName: formValues.username,
        //     LastName: "",
        //     mx_Pincode: formValues.pin,
        //     mx_Date_of_Birth: "",
        //     mx_PAN: formValues.pan,
        //     mx_City: formValues.city,
        //     Phone: "",
        //     Mobile: formValues.mobile.slice(-10),
        //     EmailAddress: formValues.email,
        //     LandingPage: formValues.CompleteUrl,
        //   },
        // };
        // // console.log("criff payload: ", criffPayload);
        // const encryptedCriffPayload = await encryptBody(criffPayload);
        // // console.log("encrypted criff payload: ", encryptedCriffPayload);

        // const criffResp = await callLSQLapp(encryptedCriffPayload, "CRIF", {
        //   requestFrom: "HL_LP",
        // });
        // // console.log("criff resp: ", criffResp);

        // const cibilScore = criffResp?.data?.message?.cibilScore;

        // const homeLoanAmountReq = formValues.homeLoanAmountRequired;
        // // console.log("loan amount req: ", homeLoanAmountReq);

        // if (
        //   homeLoanAmountReq === "Less than 5 Lakhs" ||
        //   (cibilScore && [87, 77, 65].includes(Number(cibilScore)))
        // ) {
        //   // console.log("CIBIL score exists and is one of 87, 77, or 65");
        //   navigate(`/thankyou-not-eligible?id=${leadid}`);
        // } else {
        //   navigate(`/thankyou?id=${leadid}`);
        // }
      } else {
        setApplyBtnDisable(false);
        //Trigger AA formSubmissionFail event
        formSubmissionFailEvent();
        console.log("lead not created.");
      }
    } else {
      //Trigger AA formFieldError event
      formFieldErrorEvent(validateFormValues);
    }
  };
  return (
    <>
      <article
        className={`banner_section position-relative  ${
          newMargin ? "m_update" : null
        }  `}
      >
        <div className="banner_img">
          <picture>
            {/* <source rel="preload"  media="(max-width: 767px)" srcset="dist/img/banner_mobile.webp" type="image/webp"> */}
            <source
              rel="preload"
              media="(max-width:767.5px)"
              srcSet="dist/img/lap_banner_mobile.png"
              alt="ICICI Bank Banner"
              width={767}
              height={241}
            />
            {/* <source rel="preload"  srcset="dist/img/banner_mobile.webp" type="image/webp"> */}
            <img
              rel="preload"
              src="dist/img/lap_banner_desktop.png"
              alt="Banner img"
              width={1920}
              height={764}
              className="img-fluid d-none d-md-block"
            />
            <img
              rel="preload"
              src="dist/img/lap_banner_mobile.png"
              alt="Banner img"
              width={1920}
              height={764}
              className="img-fluid d-block d-md-none"
            />
          </picture>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-7 col-12">
              <div className="form_wrap" id="lap_form">
                <div className="form_heading" id="apply_home_loan">
                  <h4>Apply now for quick loan processing</h4>
                </div>
                <form name="contactForm" method="post" onSubmit={handleSubmit}>
                  <div className="my-md-2 my-3">
                    <input
                      type="text"
                      name="username"
                      id="username"
                      placeholder="Name"
                      value={formValues.username}
                      onInput={(e) =>
                        (e.target.value = e.target.value.replace(
                          /[^a-zA-Z\s]/gi,
                          "",
                        ))
                      }
                      onChange={handleChange}
                    />
                  </div>
                  {formErrors.username && (
                    <span className="error">{formErrors.username}</span>
                  )}
                  <div className="my-md-2 my-3">
                    <input
                      type="email"
                      name="email"
                      id="email"
                      placeholder="Email"
                      value={formValues.email}
                      onChange={handleChange}
                    />
                  </div>
                  {formErrors.email && (
                    <span className="error">{formErrors.email}</span>
                  )}

                  <div className="my-md-2 my-3 position-relative">
                    <div className="form-control-wrap icons text-field-with-icon position-relative">
                      <span className="text-icon number-span">+91 </span>
                      <input
                        type="number"
                        name="mobile"
                        placeholder="Mobile Number"
                        pattern="\d{10}"
                        id="mobile_number"
                        style={{ textAlign: "left", paddingLeft: "40px" }}
                        value={
                          formValues.mobile > 0
                            ? formValues.mobile.replace(/^[0-5]+/, "")
                            : ""
                        }
                        onChange={handleChange}
                        onInput={(e) =>
                          (e.target.value = e.target.value.slice(0, 10))
                        }
                        disabled={disableMobileField}
                      />

                      {otpsent && timer <= 0 ? (
                        <div className="resend_btn ms-1">
                          <button
                            className=""
                            type="button"
                            id="resendBTN"
                            onClick={() =>
                              sendOTPText(formValues.mobile, "resend")
                            }
                            style={{ display: resendBtnDisplay }}
                            disabled={disableVerifiedButton}
                          >
                            {otpBtnText}
                          </button>
                        </div>
                      ) : (
                        <span
                          className="timerOTP timer_wrapper text-center ms-1"
                          id="timer"
                          style={{ display: timerDisplay }}
                        >
                          {" "}
                          00:
                          {timer.toString().length < 2
                            ? timer.toString().padStart(2, "00")
                            : timer}
                        </span>
                      )}
                    </div>
                  </div>
                  {formErrors.mobile && (
                    <span className="error">{formErrors.mobile}</span>
                  )}

                  <div className="my-md-2 my-3 d-flex align-items-center mt-1 ">
                    <input
                      type="number"
                      min="0"
                      name="otp"
                      placeholder="OTP"
                      className="ms-0"
                      id="otp"
                      value={formValues.otp}
                      onChange={handleChange}
                      onInput={(e) =>
                        (e.target.value = e.target.value.slice(0, 6))
                      }
                      disabled={disableOTPField}
                    />
                  </div>
                  {formErrors.otp && (
                    <span className="error">{formErrors.otp}</span>
                  )}
                  <div className="col-12 my-md-2 my-3">
                    <input
                      type="text"
                      name="pan"
                      placeholder="PAN Card Number"
                      id="pan"
                      value={formValues.pan ? formValues.pan : ""}
                      onChange={handleChange}
                      onInput={(e) =>
                        (e.target.value = e.target.value.slice(0, 10))
                      }
                    />
                  </div>
                  {formErrors.pan && (
                    <span className="error">{formErrors.pan}</span>
                  )}

                  {/* <div className="col-12 my-md-2 my-3">
                    <input
                      type="text"
                      name="homeLoanAmountRequired"
                      placeholder="Loan Against Property Amount Required"
                      value={formValues.homeLoanAmountRequired}
                      onChange={handleChange}
                    />
                  </div>
                  {formErrors.homeLoanAmountRequired ? <span className="error">{formErrors.homeLoanAmountRequired}</span> : <span className="noError">{formValues.amountInWords}</span>}
                     */}
                  <div className="col-12 my-md-2 my-3">
                    <label className="d-block mb-2 inline-label">
                      Loan Against Property Amount Required{" "}
                    </label>
                    <div className="radio-group">
                      <input
                        type="radio"
                        name="homeLoanAmountRequired"
                        id="lt10l"
                        value="Less than 5 Lakhs"
                        onChange={handleChange}
                      />
                      <label className="ms-2" htmlFor="lt10l">
                        Less than 5 Lakhs
                      </label>

                      <input
                        type="radio"
                        className="ml-3"
                        name="homeLoanAmountRequired"
                        id="gt10l"
                        value="Greater than 5 Lakhs"
                        onChange={handleChange}
                      />
                      <label className="ms-2" htmlFor="gt10l">
                        Greater than 5 Lakhs
                      </label>
                    </div>
                  </div>

                  {formErrors.homeLoanAmountRequired && (
                    <span className="error">
                      {formErrors.homeLoanAmountRequired}
                    </span>
                  )}

                  {/* <div className="col-12 my-md-2 my-3">
                    <select name="homeLoanAmountRequired" onChange={handleChange} value={formValues.homeLoanAmountRequired || ''}>
                      <option value="" disabled hidden>Home Loan Amount Required</option>
                      <option value="More than 75 Lacs">More than 75 Lacs</option>
                      <option value="50 Lacs to 75 Lacs">50 Lacs to 75 Lacs</option>
                      <option value="20 Lacs to 50 Lacs">20 Lacs to 50 Lacs</option>
                      <option value="Less than 20 Lacs">Less than 20 Lacs</option>
                      <option disabled>Loan requirement below 20 lakhs is not eligible for digital application </option>
                    </select>
                  </div>
                  {formErrors.homeLoanAmountRequired && <span className="error">{formErrors.homeLoanAmountRequired}</span>} */}

                  {/* <div className="col-12 my-md-2 my-3">
                    <select name="propertyIdentified" onChange={handleChange} value={formValues.propertyIdentified || ''}>
                      <option value="" disabled hidden>Property Identified?</option>
                      <option value="Yet to be identified">Yet to be identified</option>
                      <option value="Identified - Under Construction">Identified - Under Construction</option>
                      <option value="Identified – Construction completed">Identified – Construction completed</option>
                    </select>
                  </div>
                  {formErrors.propertyIdentified && <span className="error">{formErrors.propertyIdentified}</span>} */}

                  <div className="row my-md-2 my-3">
                    <div className="col-6 my-1 pt-xl-1 pt-md-2 pb-3 pb-md-2 pe-0">
                      <input
                        className="mb-2 ms-md-0 ms-1"
                        type="number"
                        min="0"
                        placeholder="Property PIN Code"
                        id="pincode"
                        name="pin"
                        value={formValues.pin}
                        onChange={handleChange}
                        onInput={(e) =>
                          (e.target.value = e.target.value.slice(0, 6))
                        }
                      />
                      {formErrors.pin && (
                        <span className="error">{formErrors.pin}</span>
                      )}
                    </div>

                    <div className="col-6 my-1 pt-xl-1 pt-md-2 pb-3 pb-md-2">
                      <input
                        className="mb-2"
                        type="text"
                        name="city"
                        placeholder="City"
                        value={cityName}
                        disabled
                        readOnly
                      />
                      {formErrors.city && (
                        <span className="error">{formErrors.city}</span>
                      )}
                    </div>
                  </div>
                  <div className="checkbox row">
                    <div className="col-1 p-0 check-input">
                      <input
                        type="checkbox"
                        name="terms_chk"
                        id="terms_chk"
                        defaultChecked={checked}
                        onClick={() => setChecked(!checked)}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-11 p-0 ">
                      <label htmlFor="terms_chk">
                        I agree to be bound by these{" "}
                        <a
                          href="https://www.icicibank.com/terms-condition?_ga=2.118267849.1136189618.1691735643-1242154132.1669272467&_gac=1.12322502.1690541816.CjwKCAjwzo2mBhAUEiwAf7wjkoyyQmnJ5WqQjMlsIHf9CAvAAk_v7Bta0weRuO-ee9kv90Pa2v3vrxoCzTcQAvD_BwE"
                          target="_blank"
                          style={{ textDecoration: "none" }}
                          onClick={() => {
                            handleFormStart();
                            ctaClickEvent(
                              "terms & conditions",
                              "lead form",
                              "text link",
                              0,
                              "https://www.icicibank.com/terms-condition?_ga=2.118267849.1136189618.1691735643-1242154132.1669272467&_gac=1.12322502.1690541816.CjwKCAjwzo2mBhAUEiwAf7wjkoyyQmnJ5WqQjMlsIHf9CAvAAk_v7Bta0weRuO-ee9kv90Pa2v3vrxoCzTcQAvD_BwE",
                            );
                          }}
                          onContextMenu={() => {
                            handleFormStart();
                            ctaClickEvent(
                              "terms & conditions",
                              "lead form",
                              "text link",
                              0,
                              "https://www.icicibank.com/terms-condition?_ga=2.118267849.1136189618.1691735643-1242154132.1669272467&_gac=1.12322502.1690541816.CjwKCAjwzo2mBhAUEiwAf7wjkoyyQmnJ5WqQjMlsIHf9CAvAAk_v7Bta0weRuO-ee9kv90Pa2v3vrxoCzTcQAvD_BwE",
                            );
                          }}
                        >
                          {" "}
                          Terms & Conditions{" "}
                        </a>{" "}
                        and{" "}
                        <a
                          href="#"
                          onClick={() => {
                            handleOpenModal();
                            handleFormStart();
                            ctaClickEvent(
                              "open: Most Important Terms & Conditions",
                              "lead form",
                              "text link",
                              0,
                              "na",
                            );
                          }}
                          style={{ textDecoration: "none" }}
                        >
                          Most Important Terms & Conditions
                        </a>{" "}
                        prescribed by ICICI Bank Limited. I permit ICICI Bank
                        Limited to share my contact details with ICICI Home
                        Finance Company. Further, I specifically permit
                        representatives from ICICI Bank Limited & ICICI Home
                        Finance Company to reach out to me through my registered
                        e-mail, phone, SMS, WhatsApp messaging, or any other
                        electronic mode or other messaging or social media
                        platforms in relation to my home loan application.
                      </label>
                      <Modal
                        show={showModal}
                        onHide={() => {
                          handleCloseModal();
                          ctaClickEvent(
                            "close: Most Important Terms & Conditions",
                            "popup",
                            "icon",
                            0,
                            "na",
                          );
                        }}
                      >
                        <Modal.Header
                          closeButton
                          onClick={() => {
                            handleCloseModal();
                            ctaClickEvent(
                              "close: Most Important Terms & Conditions",
                              "popup",
                              "button",
                              0,
                              "na",
                            );
                          }}
                        >
                          <Modal.Title>TERMS AND CONDITIONS</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <b>DECLARATION</b> <br />
                          I/We hereby confirm my/our interest in availing loan
                          facility in the form of (i.e. Home Loan /Loan Against
                          Property/Balance Transfer/Office Premises Loan/Top
                          up)from ICICI Bank Limited (“ICICI Bank”) and in
                          relation thereto I have applied for the loan facility
                          by visiting the [www.icicibank.com] (“Website”) by
                          submitting my application electronically.
                          <br />
                          <br />
                          I/We hereby confirm that I/we have authorized the
                          representative of ICICI Bank to enter the application
                          details in the electronic application form on my/our
                          behalf in accordance with the instructions/information
                          given by me/us in the electronic application form."
                          <br />
                          <br />
                          I/We have reviewed and verified the details entered by
                          ICICI Bank’s representative in the electronic
                          application form and declare the same to be true,
                          correct and updated. I/We hereby confirm that and the
                          electronic application form has been submitted by
                          ICICI Bank’s representative post my/our review,
                          verification and confirmation of the application
                          details.",
                          <br />
                          <br />
                          I/We confirm that the information submitted by me/us
                          electronically and the details already available with
                          ICICI Bank (if any) are true, correct, complete and up
                          to date in all respects and that such information can
                          be relied upon by ICICI Bank for the purpose of loan
                          facility.
                          <br />
                          <br />
                          I/we understand that the processing fee is a one-time
                          non-refundable fee and is collected by ICICI Bank for
                          the purpose of processing my/our loan facility request
                          and such processing fee once paid, will not be
                          refunded in any circumstances.
                          <br />
                          <br />
                          I/We understand that the loan facility, if sanctioned,
                          shall be subject to the customary terms and conditions
                          as applicable to the product.
                          <br />
                          <br />
                          I/We hereby authorize ICICI Bank to collect
                          information/personal data from me and other agencies
                          including Unique Identification authority of India
                          (UIDAI), Credit information companies (CICs), and
                          conduct verification/due diligence, make references
                          and enquiries with the group companies, that ICICI
                          Bank may deem fit, for the purpose of the loan
                          facility.
                          <br />
                          <br />
                          I/We understand that sanction of loan is at the sole
                          discretion of ICICI Bank. ICICI Bank reserves the
                          right to reject the application without assigning any
                          reason and shall not held liable for such rejection.
                          With respect to Instant loan, if any, ICICI Bank
                          reserves the right at any time to withdraw the loan
                          offer and/ or modify, alter the Instant loan, terms
                          and conditions and / or ask for any additional
                          document /information from customer. The loan facility
                          will only be established/disbursed upon completion of
                          definitive loan documents and other terms and
                          conditions as ICICI Bank may reasonably require.
                          <br />
                          <br />
                          I/We understand that the disbursement of funds under
                          the sanction letter accepted by me/us is subject to
                          completion of legal and technical analysis of the
                          property to be mortgaged, to the satisfaction of ICICI
                          Bank, wherein the title to the property can be
                          ascertained to be clear and marketable.
                          <br />
                          <br />
                          I/We hereby confirm that the there are no insolvency
                          proceeding initiated against me/us nor I/we has ever
                          been adjudicated insolvent / bankrupt
                          <br />
                          <br />
                          I/We undertake to inform ICICI Bank / its agents
                          regarding the change in the residential addresses to
                          provide any further information that ICICI Bank may
                          require.
                          <br />
                          <br />
                          I/We hereby authorize ICICI Bank to exchange, share or
                          part with all the information, data or document in
                          relation to the loan application including but not
                          limited to the credit repayment, history or default,
                          if any, committed by the me/us to credit bureaus,
                          agencies, statutory bodies, information utilities.
                          <br />
                          <br />
                          Except to the extent disclosed to ICICI Bank herein,
                          no Chairman / Managing Director or director or a
                          relative/near relation of a Chairman / Managing
                          Director or director of a banking company (including
                          ICICI Bank and its subsidiaries) or mutual
                          funds/venture capital funds or a relative/near
                          relation of a senior officer of ICICI Bank, as
                          specified by RBI, is: a partner of our concern, or a
                          trustee, member, director, manager, employee of our
                          concern, or of our subsidiary, or our holding company,
                          or a guarantor on my/our behalf, or holds substantial
                          interest in our concern or my/our subsidiary or
                          holding company. For the purpose of this clause the
                          terms “relative”, “near relation” & “senior officer”
                          shall have the same meaning ascribed to them under the
                          RBI master circular on Loans and Advances dated July
                          1, 2015, para 2.2.1.8 and shall include any amendments
                          made thereto.
                          <br />
                          <br />
                          I/We undertake to inform as to any change in my
                          occupation/residential address. /mobile and to provide
                          any further information/document that ICICI bank may
                          require from time to time. In case of
                          non-provision/non-updation of mobile number, I/We
                          would not receive SMS alerts pertaining to the account
                          and shall not hold ICICI Bank liable for the same.
                          <br />
                          <br />
                          I/We acknowledge that ICICI Bank reserves the right to
                          retain such documents submitted with this application
                          and will not return the same to the me/us.
                          <br />
                          <br />
                          I/We hereby declare and affirm that the I/we have not
                          made any payments in cash.
                          <br />
                          <br />
                          I/We hereby authorize ICICI Bank to store all
                          information/data provided herein including personal
                          and business information with ICICI group
                          companies/other institutions/ such other persons as
                          may be necessary/ required for the purpose of,
                          including but not limited to, marketing, cross selling
                          of various products and services etc to me/us, use or
                          process the aforesaid information/data by such
                          person/s, or furnishing of the processed information/
                          data/ products thereof to other
                          Banks/Institutions/other persons as may be necessary,
                          and we shall not hold ICICI Bank liable in connection
                          with the use of such information or otherwise.
                          <br />
                          <br />
                          I/We hereby authorize ICICI Bank to exchange, share or
                          part with all information/data provided herein
                          including personal and business information with ICICI
                          group companies/other institutions/ such other persons
                          as may be necessary/ required for the purpose of,
                          including but not limited to, marketing, cross selling
                          of various products and services etc to me/us, use or
                          process the aforesaid information/data by such
                          person/s, or furnishing of the processed
                          information/data/products thereof to other
                          Banks/Institutions/other persons as may be necessary,
                          and we shall not hold ICICI Bank liable in connection
                          with the use of such information or otherwise.
                          <br />
                          <br />
                          I/We hereby declare that the information of GSTIN with
                          respect to the number and billing address is correct
                          and ICICI Bank can update the same in its records.
                          I/We hereby declare that the information provided can
                          be used by ICICI Bank for the purposes of charging GST
                          and reporting of transactions on the GSTN portal and
                          for other related aspects in relation to reporting as
                          stated under GST Act and applicable rules in this
                          regard.
                          <br />
                          <br />
                          I/We may share, exchange or deliver
                          instruction/information/document electronically to
                          ICICI Bank through email. I/We acknowledge and
                          understand that communication through e-mail cannot be
                          guaranteed to be secured or error free and such
                          information could be incomplete/unsafe and subject to
                          tampering and unauthorized access and I/we shall not
                          hold ICICI Bank responsible or liable for relying
                          and/or acting on such
                          instructions/document/information received through
                          email.
                          <br />
                          <br />
                          I/We hereby consent to receiving information from
                          Central KYC Registry through SMS/Email on the
                          registered number/email address
                          <br />
                          <br />
                          I/We agree to receive update on various products and
                          services related information and special offer from
                          ICICI Bank/group companies and other entities via
                          email alerts, or SMS alerts or phone call.
                          <br />
                          <br />
                          <b>
                            REVERSE SOLICITATION DECLARATIONS (APPLICABLE FOR
                            NRI/OCI CUSTOMERS)
                          </b>
                          <br />
                          <br />
                          I/We hereby certify that I am/we are resident outside
                          India who is/are either citizen of India or Person of
                          Indian Origin (“Non-Resident Indian”) as defined under
                          the Foreign Exchange Management Act, 1999 as amended,
                          modified or updated from time to time.
                          <br />
                          <br />
                          I/We confirm that I/we am/are interested in availing
                          loan facility in the form of Home Loan /Loan Against
                          Property/Balance Transfer/Office Premises Loan/Top up
                          (“Facility”) from ICICI Bank Limited, India (“ICICI
                          Bank”) and in this regard I/We hereby agree,
                          acknowledge and confirm that:
                          <br />
                          <br />
                          (a) I/we have voluntarily applied for the loan
                          facility by visiting the [website]
                          <br />
                          <br />
                          (b) The decision to avail the loan facility, through
                          ICICI Bank’s website is my/our own independent
                          decision, which has been considered after personal
                          analysis and careful consideration of the risks,
                          benefits, terms and conditions taking into account
                          my/our investment objectives, financial situation and
                          particular needs.
                          <br />
                          <br />
                          (c) I/We hereby declare that ICICI Bank has not
                          influenced/communicated/ solicited/ marketed about
                          Facility and that I/we have sought the assistance of
                          ICICI Bank without any liability for ICICI Bank. I/We
                          shall not hold ICICI Bank liable or responsible in any
                          manner whatsoever or make any claim against ICICI Bank
                          or the regulators in Oman, Qatar, QFC, Singapore, UAE,
                          DIFC, Bahrain or India in relation to the management
                          or operations of the Facility.
                          <br />
                          <br />
                          (d) There are/shall be no legal or regulatory
                          prohibitions or impediments, as per the laws of my/our
                          home country, against my/our maintaining my/our
                          relationship with ICICI Bank, including availing the
                          aforementioned Facility.
                          <br />
                          <br />
                          (e) In availing the Facility, I/we shall ensure that
                          I/we are in full compliance with all laws and
                          regulations, including, without limitation, all
                          applicable exchange control/taxation laws/regulations
                          in my/our home/host country and I/ we am/ taking this
                          decision based on my/ our analysis or legal counsel.
                          <br />
                          <br />
                          (f) I/We shall obtain all necessary regulatory
                          approvals, if required, in connection with availing
                          the Facility and/ or entering into any such
                          transactions and shall promptly make all necessary
                          regulatory reporting, as and when required, to the
                          relevant authorities in my/our home/host country or
                          any other country of residence where I/we may relocate
                          to in future and I/we agree to furnish to ICICI Bank,
                          upon request, copies of the approvals/reports, if any
                          <br />
                          <br />
                          (g) I/We are aware that the Facility availed by me/us
                          may or may not be serviced by the offshore
                          branches/representative offices/subsidiaries of ICICI
                          Bank located outside India and shall further be
                          subject to applicability of the applicable laws in
                          such jurisdiction.
                          <br />
                          <br />
                          (h) I/We shall indemnify and keep indemnified ICICI
                          Bank, its affiliates, directors, representatives,
                          employees and agents against any/ all direct,
                          indirect, special, incidental or consequential losses,
                          costs, expenses, suits, damages, whatsoever, which
                          ICICI Bank, its affiliates, directors,
                          representatives, employees and agents may suffer, pay
                          or incur by reason of or in connection with arising
                          out of the products/ services including the Facility
                          including t that have been provided to me/us on my/
                          our specific request, including legal proceedings
                          taken against ICICI Bank, its affiliates, directors,
                          representatives, employees and agents.
                          <br />
                          <br />
                          (i) I/We acknowledge that relying solely on my/our
                          representations, warranties, undertakings and
                          statements contained herein, ICICI Bank is agreeing to
                          establish/continue its relationship with me/us and
                          providing the Facility to me/us.
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="secondary"
                            onClick={() => {
                              handleCloseModal();
                              ctaClickEvent(
                                "close: Most Important Terms & Conditions",
                                "popup",
                                "button",
                                0,
                                "na",
                              );
                            }}
                          >
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </div>
                    {formErrors.terms_chk && (
                      <span className="error">{formErrors.terms_chk}</span>
                    )}
                  </div>

                  <div className="applynow">
                    <button
                      type="submit"
                      disabled={disableApplyBtn}
                      onClick={() => {
                        handleFormStart();
                      }}
                    >
                      Apply Now
                    </button>
                  </div>
                </form>
                <ToastContainer />
              </div>
            </div>
          </div>
        </div>
      </article>
    </>
  );
}

export default Form;
